import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/webp/logo.webp';

interface OnboardingProgressHeaderProps {
  step: 1 | 2 | 3 | 4;
}

const STEP_TOTAL = 4;

const OnboardingProgressHeader: React.FC<OnboardingProgressHeaderProps> = ({ step }) => {
  const { i18n } = useTranslation();

  return (
    <div
      style={{
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 8,
        background: '#F9FAFB',
      }}
    >
      <img src={logo} alt="Kol Torah" style={{ height: 40, objectFit: 'contain' }} />
      {/* Step progress bars - fill from the reading-start side of the active language */}
      <div
        dir={i18n.dir(i18n.language)}
        style={{
          display: 'flex',
          gap: 4,
          marginTop: 10,
        }}
      >
        {Array.from({ length: STEP_TOTAL }, (_, i) => (
          <div
            key={i}
            style={{
              width: 25,
              height: 4,
              borderRadius: 9999,
              background: i === step - 1 ? '#3B7BF4' : '#D0D5DD',
              transition: 'background 0.3s ease',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default OnboardingProgressHeader;
